module.exports = __webpack_public_path__ + "img/cloud_left.cb688bea.png";